import {
  GET_ALL_ORDERS
} from '../../actionTypes';
import {
  SUCCESS
} from '../../../utils/status';


export default function reducer(state = {}, action) {
  let nextState;

  if (action.status === SUCCESS) {
    switch (action.type) {
      case GET_ALL_ORDERS:
        nextState = {...state};
        let orders = action.data.orders;
        orders.forEach(function (order) {
          nextState[order.id] = {...nextState[order.id], ...order};
        });
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/entity/order.js